import React, { Fragment, lazy, Suspense } from "react";
import "./App.css";
import "swiper/css";
import "swiper/css/navigation";
import { BrowserRouter } from "react-router-dom";
import DataLoader from "./Utils/DataLoader";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store } from "./Redux/Store";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// const CreateRoutes = lazy(() => import("./routes/routes"));

import CreateRoutes from "./routes/routes"; // Importing directly for simplicity

function App() {
  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      // Scrolls to top on every route change
      window.scrollTo(0, 0);
    }, [pathname]);

    return null; // This component doesn't render anything
  }
  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<DataLoader />}>
            <CreateRoutes />
          </Suspense>
        </BrowserRouter>
        <ToastContainer theme="dark" position="top-right" />
      </Provider>
    </>
  );
}

export default App;